import { proProfileQueryOptions } from "api/queries/pros";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { id: number };

export const queries = (input: QueriesInput): Array<WarmableQuery> => [proProfileQueryOptions(input.id)];
